@if (formField.scope === 'GLOBAL' || formField.real === false) {
  <div [formGroup]="form">
    <label [matTooltip]="formField.description">{{ formField.name }} @if (formField.required) {
      <span
        style="color: red; position: relative; top: 3px;"
      >*</span>
    }</label>
    <div class="flex-100" >
      @if (formField.type === 'TEXT') {
        <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
          <mat-form-field appearance="fill"   class="flex-align-center flex-100">
            <input matInput [formControlName]="formField.jsonProperty" [type]="'text'"
              (focusout)="formField.tag === 'TAG' ? findTagExists() : null" class="flex-100"
              >
          </mat-form-field>
        </div>
      }
      @if (formField.type === 'NUM') {
        <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
          <mat-form-field appearance="fill"   class="flex-align-center flex-100">
            <input matInput [formControlName]="formField.jsonProperty" [type]="'number'"
              (focusout)="numberValidation(formField.jsonProperty)" class="flex-100"
              >
          </mat-form-field>
        </div>
      }
      @if (formField.type === 'BOOL') {
        <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
          <mat-form-field appearance="fill"   class="flex-align-center flex-100">
            <mat-select [formControlName]="formField.jsonProperty" class="flex-100" >
              @for (option of formField.options; track option) {
                <mat-option
                [value]="option.value">{{ option.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (formField.type === 'TEXTAREA') {
        <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
          <mat-form-field appearance="fill"   class="flex-align-center flex-100">
            <textarea matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="3"
              [formControlName]="formField.jsonProperty" class="flex-100"
              >
            </textarea>
          </mat-form-field>
        </div>
      }
      @if (formField.type === 'SELECT') {
        <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
          <mat-form-field appearance="fill"   class="flex-align-center flex-100">
            <mat-select [formControlName]="formField.jsonProperty" class="flex-100" >
              @for (option of formField.options; track option) {
                <mat-option
                [value]="option.value">{{ option.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (formField.type === 'MULTI_SELECT') {
        <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
          <mat-form-field appearance="fill"   class="flex-align-center flex-100">
            <mat-select [formControlName]="formField.jsonProperty"
              multiple class="flex-100">
              <mat-option *ngFor="let option of formField.options as Array"
              [value]="option.value">{{ option.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if (formField.type === 'IMAGE') {
        <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
          <mat-form-field appearance="fill"   class="flex-align-center flex-100">
            <input matInput [formControlName]="formField.jsonProperty" [type]="'text'"
              (focusout)="imageValidation(formField.jsonProperty)" class="flex-100"
              >
          </mat-form-field>
        </div>
      }
    </div>
    <div class="action-buttons-container">
      @if (formField.showLocaleIcons !== false && !formField.metadata?.localeSupport) {
        <emm-language-global-icon
          (click)="editLocale()"
        ></emm-language-global-icon>
      }
      @if (formField.showLocaleIcons !== false && formField.metadata?.localeSupport) {
        <emm-language-dialog-icon
          (click)="editLocale()"
        ></emm-language-dialog-icon>
      }
    </div>
  </div>
}

@if ((formField.scope !== 'GLOBAL' && formField.scope !== 'LOCAL') && formField?.metadata?.type) {
  <div [formGroup]="form">
    <label [matTooltip]="formField.description">{{ formField.name }} @if (formField.metadata.required) {
      <span
        style="color: red; position: relative; top: 3px;"
      >*</span>
    }
  </label>
  <div class="flex-100" >
    @if (formField.metadata.type === 'TEXT') {
      <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
        <mat-form-field appearance="fill"   class="flex-align-center flex-100">
          <input matInput [formControlName]="formField.jsonProperty" [type]="'text'"
            (focusout)="formField.tag === 'TAG' ? findTagExists() : null" class="flex-100"
            >
        </mat-form-field>
      </div>
    }
    @if (formField.metadata.type === 'NUM') {
      <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
        <mat-form-field appearance="fill"   class="flex-align-center flex-100">
          <input matInput [formControlName]="formField.jsonProperty" [type]="'number'"
            (focusout)="numberValidation(formField.jsonProperty)" class="flex-100"
            >
        </mat-form-field>
      </div>
    }
    @if (formField.metadata.type === 'BOOL') {
      <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
        <mat-form-field appearance="fill"   class="flex-align-center flex-100">
          <mat-select [formControlName]="formField.jsonProperty" class="flex-100" >
            @for (option of formField.metadata.options; track option) {
              <mat-option
              [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (formField.metadata.type === 'TEXTAREA') {
      <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
        <mat-form-field appearance="fill"   class="flex-align-center flex-100">
          <textarea matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="3"
            [formControlName]="formField.jsonProperty" class="flex-100"
            >
          </textarea>
        </mat-form-field>
      </div>
    }
    @if (formField.metadata.type === 'SELECT') {
      <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
        <mat-form-field appearance="fill"   class="flex-align-center flex-100">
          <mat-select [formControlName]="formField.jsonProperty" class="flex-100" >
            @for (option of formField.metadata.options; track option) {
              <mat-option
              [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (formField.metadata.type === 'MULTI_SELECT') {
      <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
        <mat-form-field appearance="fill"   class="flex-align-center flex-100">
          <mat-select [formControlName]="formField.jsonProperty"  multiple class="flex-100">
            <mat-option *ngFor="let option of formField.metadata.options as Array"
            [value]="option.value">{{ option.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (formField.metadata.type === 'IMAGE') {
      <div [ngClass]="isDarkMode ? getDarkModeInputCssClass() : getInputCssClass()">
        <mat-form-field appearance="fill"   class="flex-align-center flex-100">
          <input matInput [formControlName]="formField.jsonProperty" [type]="'text'"
            (focusout)="imageValidation(formField.jsonProperty)" class="flex-100"
            >
        </mat-form-field>
      </div>
    }
  </div>
  <div class="action-buttons-container">
    @if (formField.showLocaleIcons !== false && !formField.metadata.localeSupport) {
      <emm-language-global-icon
        (click)="editLocale()"
      ></emm-language-global-icon>
    }
    @if (formField.showLocaleIcons !== false && formField.metadata.localeSupport) {
      <emm-language-dialog-icon
        (click)="editLocale()"
      ></emm-language-dialog-icon>
    }
  </div>
</div>
}
